import React from 'react';

const WorksFeedback = () => {
    return (
        <div className="works-feedback-container">
            <div className="works-feedback-overlay">
                <div className="works-feedback-title">Do you like OUR WORK so far?</div>
                <div className="works-feedback-title">Let's talk about YOUR PROJECT!</div>
                <button className="works-feedback-btn">GET IN TOUCH</button>
            </div>
        </div>
    )
}

export default WorksFeedback;